<script>
  import {
    pageToLoad,
    flowData,
    appMode,
    selectedWorkshopID,
    userWorkshops,
    openWorkshops,
    sliderToLoad,
    portalStatus,
  } from "../scripts/stores.js";
  import { portalSub } from "../scripts/firebase.js";
  import { formatTimestamp, formatTimeRange } from "../scripts/utils.js";
  import { onDestroy } from "svelte";

  let workshop = {};
  let alreadyRegistered = false;
  let isOpen = true;
  let isTime = false;

  let portalUnsub;
  $: alreadyRegistered && (portalUnsub = portalSub($selectedWorkshopID));

  onDestroy(() => {
    if (portalUnsub) {
      console.log("unsubscribing from the portal");
      portalUnsub();
    }
  });

  // can't depend on the reactive blocks getting called before the stuff that shows up after it.
  $: {
    if ($selectedWorkshopID in $userWorkshops) {
      workshop = $userWorkshops[$selectedWorkshopID];
      alreadyRegistered = true;
      isOpen = true;
    } else if ($selectedWorkshopID in $openWorkshops) {
      workshop = $openWorkshops[$selectedWorkshopID];
      isOpen = true;
    } else {
      isOpen = false;
    }
    // make sure closed workshops still display for people who have registered
    if (
      workshop &&
      workshop.enrollmentStatus == "closed" &&
      !alreadyRegistered
    ) {
      isOpen = false;
    }
  }

  // can't destructure workshop because can only destructure upon initializing and you have to initialize before the reactive declaration

  let nextPage = "login";

  const signUp = async (id) => {
    $flowData.loginDestination = "pay";
    pageToLoad.set(nextPage);
  };

  const enterWorkshop = () => {
    pageToLoad.set("workshopHome");
  };
</script>

<main class="page">
  {#if isOpen}
    <h1>{workshop.title}</h1>
    <div class="info-row">
      <div class="info-text"><p>{workshop.enrollmentStatus}</p></div>
    </div>
    <div class="info-row">
      <div class="mini-icon">
        <img src="./images/calendar-icon.svg" alt="Date" width="15px" />
      </div>
      <div class="info-text">{formatTimestamp(workshop.startTime).date}</div>
    </div>
    <div class="info-row">
      <div class="mini-icon">
        <img src="./images/clock-icon.svg" alt="Date" width="15px" />
      </div>
      <div class="info-text">
        {formatTimeRange(workshop.startTime, workshop.endTime)}
      </div>
    </div>
    <p><strong>Maximum group size:</strong> {workshop.capacity}</p>
    <p><strong>Price: </strong>${workshop.price} USD</p>
    <p>{workshop.description}</p>
    {#if alreadyRegistered}
      <div class="registered">
        <img src="./images/check-icon.svg" alt="Success" width="50px" />
        <p>You're registered for this workshop!</p>
        <p><strong>Zoom link:</strong><br /> {@html workshop.zoomInvite}</p>
        {#if $portalStatus[$selectedWorkshopID]}
          <span class="link-internal" on:click={enterWorkshop}
            ><h2>Enter Workshop</h2></span
          >
        {:else}
          <p>
            Check back here when the workshop starts for a portal into the
            workshop.
          </p>
        {/if}
      </div>
    {:else}
      <div class="button-primary" on:click={() => signUp(workshop.id)}>
        Register
      </div>
    {/if}
  {:else}
    <p>
      Sorry! This workshop is no longer available. It may have filled up. Please
      contact support@synthase.cc if you think there's been an error.
    </p>
  {/if}
</main>

<style>
  .info-row {
    display: flex;
    align-items: center;
    padding-top: 4px;
    padding-bottom: 4px;
  }
  .mini-icon {
    display: inline-flex;
    margin-right: 5px;
  }
  h1 {
    text-align: center;
  }
  .registered {
    background-color: #00f10033;
    padding: 10px;
    outline: solid 1px #ffffffaa;
    outline-offset: -5px;
    box-sizing: border-box;
    text-align: center;
  }
</style>
